'use strict';
var _ = require('underscore');

/**
 *
 * @type {{
 *    Rect: {
 *      create: module.exports.Rect.create,
 *      inflate: module.exports.Rect.inflate,
 *      shrink: module.exports.Rect.shrink,
 *      overturn: module.exports.Rect.overturn,
 *     offset: module.exports.Rect.offset,
 *     setLocation: module.exports.Rect.setLocation,
 *     setSize: module.exports.Rect.setSize,
 *     topLeft: module.exports.Rect.topLeft,
 *     bottomRight: module.exports.Rect.bottomRight,
 *     topRight: module.exports.Rect.topRight,
 *     bottomLeft: module.exports.Rect.bottomLeft,
 *     center: module.exports.Rect.center,
 *     init: module.exports.Rect.init,
 *     strToRect: module.exports.Rect.strToRect,
 *     rectToStr: module.exports.Rect.rectToStr,
 *     empty: module.exports.Rect.empty,
 *     compareTo: module.exports.Rect.compareTo,
 *     contain: module.exports.Rect.contain,
 *     scale: module.exports.Rect.scale
 *   },
 *   Point: {
 *     create: module.exports.Point.create,
 *     strToPoint: module.exports.Point.strToPoint,
 *     zero: module.exports.Point.zero,
 *     offset: module.exports.Point.offset,
 *     setLocation: module.exports.Point.setLocation
 *   },
 *   Size: {
 *     create: module.exports.Size.create,
 *     scale: module.exports.Size.scale,
 *     overturn: module.exports.Size.overturn
 *   },
 *   Text: {
 *     DM_COMMA: string,
 *     DM_RETURN: string,
 *     delimitText: module.exports.Text.delimitText,
 *     delimitToParagraphs: module.exports.Text.delimitToParagraphs,
 *     delimitToWords: module.exports.Text.delimitToWords,
 *     convertSpaceToNbsp: module.exports.Text.convertSpaceToNbsp,
 *     replaceIndentSpace : module.exports.Text.replaceIndentSpace,
 *     ansiStartsStr: module.exports.Text.ansiStartsStr,
 *     ansiEndsStr: module.exports.Text.ansiEndsStr,
 *     trimRight: module.exports.Text.trimRight,
 *     removeLastEmptyRow: module.exports.Text.removeLastEmptyRow,
 *     compareTo: module.exports.Text.compareTo,
 *     replaceLast: module.exports.Text.replaceLast,
 *     isMultiLineText: module.exports.Text.isMultiLineText,
 *     decode : module.exports.Text.decode
 *   },
 *   Color: {
 *     toHex: module.exports.Color.toHex,
 *     toRGBA: module.exports.Color.toRGBA,
 *     isLight: module.exports.Color.isLight,
 *     toGay: module.exports.Color.toGay,
 *     rgbaToString: module.exports.Color.rgbaToString,
 *     toHTMLColor: module.exports.Color.toHTMLColor,
 *     setOpacity: module.exports.Color.setOpacity
 *   },
 *   Bitmap: {
 *     gay: module.exports.Bitmap.gay,
 *     invert: module.exports.Bitmap.invert,
 *     dodgeColor: module.exports.Bitmap.dodgeColor,
 *     gaussBlur: module.exports.Bitmap.gaussBlur,
 *     dissolve: module.exports.Bitmap.dissolve,
 *     hardMix: module.exports.Bitmap.hardMix,
 *     replacecolor: module.exports.Bitmap.replacecolor
 *   },
 *   Number: {
 *     toInt: module.exports.Number.toInt,
 *     toFloat: module.exports.Number.toFloat,
 *     decimalPlaces: module.exports.Number.decimalPlaces
 *   },
 *   Path: {
 *     Curve: {
 *       T: undefined,
 *       curvePointList: Array,
 *       create: module.exports.Path.Curve.create,
 *       isPointIn: module.exports.Path.Curve.isPointIn
 *     },
 *     PathData: module.exports.Path.PathData
 *   },
 *   Util: {
 *     map: module.exports.Util.map
 *   },
 *   Int: module.exports.Int,
 *   Float: module.exports.Float,
 *   clone: module.exports.clone,
 *   depthClone : module.exports.depthClone
 * }}
 */
module.exports = {
  /**
   * 区域处理
   */
  Rect: {
    create: function (left, top, width, height) {
      var rect = this.empty();
      this.setLocation(rect, left, top);
      this.setSize(rect, width, height);
      return rect;
    },
    /**
     * 扩展区域
     * @param rect
     * @param x
     * @param y
     */
    inflate: function (rect, x, y) {
      if (x) {
        rect.left -= x;
        rect.width += x * 2;
        rect.right += x;
      }
      if (y) {
        rect.top -= y;
        rect.height += y * 2;
        rect.bottom += y;
      }
    },

    /**
     * 收缩区域
     * @param rect
     * @param x
     * @param y
     */
    shrink: function (rect, x, y) {
      if (x) {
        x = -x;
      }
      if (y) {
        y = -y;
      }
      this.inflate(rect, x, y);
    },

    overturn: function (r) {
      var l, t, w, h;
      l = r.top;
      t = r.left;
      w = r.height;
      h = r.width;
      this.setLocation(r, l, t);
      this.setSize(r, w, h);
    },

    /**
     * 偏移区域
     * @param rect
     * @param x
     * @param y
     */
    offset: function (rect, x, y) {
      this.init(rect);
      if (x) {
        rect.left += x;
        rect.right += x;
      }
      if (y) {
        rect.top += y;
        rect.bottom += y;
      }
    },

    /**
     * 设置区域坐标
     * @param rect
     * @param x
     * @param y
     */
    setLocation: function (rect, x, y) {
      var offsetX = 0;
      var offsetY = 0;
      if (x) {
        offsetX = x - rect.left;
      }
      if (y) {
        offsetY = y - rect.top;
      }
      this.offset(rect, offsetX, offsetY);
    },

    /**
     * 设置区域尺寸
     * @param rect
     * @param w
     * @param h
     */
    setSize: function (rect, w, h) {
      this.init(rect);
      if (!_.isUndefined(w)) {
        rect.width = w;
        rect.right = rect.left + w;
      }
      if (!_.isUndefined(h)) {
        rect.height = h;
        rect.bottom = rect.top + h;
      }
    },

    /**
     * 返回左上角坐标
     * @param rect
     * @returns {{x: (number|*), y: (number|*)}}
     */
    topLeft: function (rect) {
      return {
        x: rect.left,
        y: rect.top
      }
    },

    /**
     * 返回右下角坐标
     * @param rect
     * @returns {{x: (number|*), y: (number|*)}}
     */
    bottomRight: function (rect) {
      return {
        x: rect.right,
        y: rect.bottom
      }
    },

    topRight: function (rect) {
      return {
        x: rect.right,
        y: rect.top
      }
    },

    bottomLeft: function (rect) {
      return {
        x: rect.left,
        y: rect.bottom
      }
    },

    /**
     * 返回区域的中心点坐标
     * @param rect
     * @returns {{x: *, y: *}}
     */
    center: function (rect) {
      return {
        x: rect.left + rect.width / 2,
        y: rect.top + rect.height / 2
      }
    },

    init: function (rect) {
      if (_.isUndefined(rect)) {
        rect = this.empty();
      }
      if (_.isUndefined(rect.left)) {
        rect.left = 0;
      }
      if (_.isUndefined(rect.top)) {
        rect.top = 0;
      }
      if (_.isUndefined(rect.right)) {
        rect.right = rect.left || 0;
      }
      if (_.isUndefined(rect.bottom)) {
        rect.bottom = rect.top || 0;
      }
      rect.width = rect.right - rect.left;
      rect.height = rect.bottom - rect.top;
      return rect;
    },
    /**
     * 字符串转换为区域
     * @param str {string{'{number,number,number,number}' or '(number,number,number,number)' or '{left:number,top:number,right:number,bottom:number}'} or object{left:number,top:number,right:number,bottom:number}}
     * @returns {*}
     */
    strToRect: function (str) {
      var rect = this.empty();
      var temp;
      if (typeof str === 'string') {
        try {
          temp = JSON.parse(str);
        } catch (e) {

        }
        if (temp && temp.left && temp.right && temp.bottom && temp.top) {
          rect = temp;
        } else {
          str = str.replace(/\{|\}|\(|\)/g, '').split(',');
          if (str.length > 0)
            rect.left = parseInt(str[0].trim(), 10) || 0;
          if (str.length > 1)
            rect.top = parseInt(str[1].trim(), 10) || 0;
          if (str.length > 2)
            rect.right = parseInt(str[2].trim(), 10) || 0;
          if (str.length > 3)
            rect.bottom = parseInt(str[3].trim(), 10) || 0;
        }
        rect.width = rect.right - rect.left;
        rect.height = rect.bottom - rect.top;

      } else {
        rect = str;
      }
      return rect;
    },

    /**
     * 把区域转换为字符串,这里转换后的字符串不是一个json结构的字符串
     * @param rect
     * @returns {‘{number,number,number,number}’}
     */
    rectToStr: function (rect) {
      return '{1,2,3,4}'.replace('1', rect.left).replace('2', rect.top).replace('3', rect.right).replace('4', rect.bottom);
    },
    /**
     * 返回一个空白区域
     * @returns {{left: number, top: number, width: number, height: number, right: number, bottom: number}}
     */
    empty: function () {
      var rect = {};
      rect.left = rect.top = rect.right = rect.bottom = rect.width = rect.height = 0;
      return rect;
    },

    /**
     * 两个区域是否完全重合
     * @param r1
     * @param r2
     * @returns {boolean}
     */
    compareTo: function (r1, r2) {
      return r1.left === r2.left && r1.top === r2.top && r1.right === r2.right && r1.bottom === r2.bottom;
    },
    /**
     * 区域中是否包含某个点或另一个区域
     * @param rect
     * @param r {rect or point}
     * @returns {boolean}
     */
    contain: function (rect, r) {
      if (!_.isUndefined(r.x) && !_.isUndefined(r.y)) {
        return r.x > rect.left && r.y > rect.top && r.x < rect.right && r.y < rect.bottom;
      } else {
        return r.left > rect.left && r.top > rect.top && r.left < rect.right && r.top < rect.bottom &&
          r.right > rect.left && r.right < rect.right && r.bottom > rect.top && r.bottom < rect.bottom;
      }
    },

    scale: function (rect, scaleX, scaleY, lockPoint) {
      var x = rect.left;
      var y = rect.top;
      var w = rect.width;
      var h = rect.height;
      var sx = scaleX;
      var sy = scaleY;
      if (!scaleX) {
        return;
      }
      if (typeof scaleY === 'undefined' || typeof scaleY === 'null') {
        sy = scaleX;
      }
      if (typeof scaleY === 'boolean') {
        sy = scaleX;
        lockPoint = scaleY;
      }
      x *= sx;
      w *= sx;
      y *= sy;
      h *= sy;
      if (!lockPoint)
        this.setLocation(rect, x, y);
      21
      this.setSize(rect, w, h);
    }
  },
  /**
   * 坐标处理
   */
  Point: {
    create: function (x, y) {
      var point = this.zero();
      this.setLocation(point, x, y);
      return point;
    },
    strToPoint: function (str) {
      var p = this.zero();
      var temp;
      if (typeof str === 'string') {
        try {
          temp = JSON.parse(str);
        } catch (e) {

        }
        if (temp && temp.x && temp.y) {
          p = temp;
        } else {
          if (str.toLowerCase().indexOf('e') !== -1) { // 这TM是科学计数法，不服能行？
            str = str.replace(/\{|\}|\(|\)/g, '').split(',');
            if (str.length > 0) {
              p.x = Math.round(Number(str[0].trim()) || 0);
            }
            if (str.length > 1) {
              p.y = Math.round(Number(str[1].trim()) || 0);
            }
          } else {
            str = str.replace(/\{|\}|\(|\)/g, '').split(',');
            if (str.length > 0) {
              p.x = parseInt(str[0].trim(), 10) || 0;
            }
            if (str.length > 1) {
              p.y = parseInt(str[1].trim(), 10) || 0;
            }
          }
        }
      } else {
        p = str;
      }
      return p;
    },

    zero: function () {
      return {
        x: 0,
        y: 0
      }
    },

    offset: function (point, x, y) {
      if (point) {
        point.x = point.x + (x || 0);
        point.y = point.y + (y || 0)
      } else {
        console.error('point is invalid');
      }
    },

    setLocation: function (point, x, y) {
      if (!point) {
        console.error('point is invalid');
      } else {
        point.x = x;
        point.y = y;
      }
    }
  },

  Size: {
    create: function (w, h) {
      return {
        width: w,
        height: h
      }
    },
    scale: function (size, scaleX, scaleY) {
      if (!scaleX) {
        return;
      }
      if (!scaleY) {
        scaleY = scaleX;
      }
      size.wdith *= scaleX;
      size.height *= scaleY;
    },

    overturn: function (size) {
      var t;
      t = size.width;
      size.width = size.height;
      size.height = t;
    }
  },

  /**
   * 文字处理
   */
  Text: {
    DM_COMMA: ',',
    DM_RETURN: '\n',
    /**
     * 文字拆分
     * @param str
     * @param dmMode
     * @param isAllowZHComma
     * @returns {Array}
     */
    delimitText: function (str, dmMode, isAllowZHComma) {
      var arr = [];
      if (str) {
        if (dmMode === this.DM_COMMA) {
          if (isAllowZHComma === undefined) {
            isAllowZHComma = true;
          }
          arr = str.split(dmMode);
          if (isAllowZHComma && arr.length === 1) {
            arr = str.split('，');
          }
        } else {
          arr = str.split(dmMode);
        }
      }
      return arr;
    },

    delimitToParagraphs: function (str) {
      return this.delimitText(str, this.DM_RETURN);
    },

    delimitToWords: function (str, isAllowZHComma) {
      return this.delimitText(str, this.DM_COMMA, isAllowZHComma);
    },
    /**
     * 空格替换
     * @param text
     * @returns {*}
     */
    convertSpaceToNbsp: function (text) {
      if (text) {
        //text = text.replace(/\n/g,'\u000a');
        return text.replace(/\s\s/g, ' \u00a0');
      }
      return text;
    },

    replaceIndentSpace: function (text) {
      var i;
      var str;
      var indent;
      var c;
      if (text) {
        indent = '';
        i = 0;
        c = 0;
        while (true) {
          str = text.charAt(i);
          if (str === ' ' || str === '\u00a0') {
            indent += '\u00a0';
            c++;
          } else {
            break;
          }
          i++;
        }
        if (c) {
          for (i = 0; i < Math.ceil(c / 3); i++) {
            indent += '\u00a0';
          }
          text = indent + text.substring(c);
        }
      }
      return text;
    },

    /**
     * 是否以某段字符开头
     * @param text
     * @param str
     * @returns {boolean}
     */
    ansiStartsStr: function (text, str) {
      if (text && str)
        return text.indexOf(str) === 0;
      return text;
    },
    /**
     * 是否以某段字符结尾
     * @param text
     * @param str
     * @returns {*|boolean}
     */
    ansiEndsStr: function (text, str) {
      var newStr;
      var newText;
      if (str)
        newStr = str.split('').reverse().join('');
      if (text)
        newText = text.split('').reverse().join('');
      if (newText && newStr)
        return this.ansiStartsStr(newText, newStr);
      return text;
    },
    /**
     * 清除末尾空格
     * @param text
     * @returns {string}
     */
    trimRight: function (text) {
      var temp;
      if (text) {
        temp = 'temp' + text;
        temp = temp.trim();
        temp = temp.substring(4);
        return temp;
      }
      return text;
    },

    /**
     * 删除最后一个空行，不论末尾有多少个空行，都只删除最后一个
     * @param text
     * @returns {*}
     */
    removeLastEmptyRow: function (text) {
      var a = this.delimitText(text, this.DM_RETURN);
      var i = a.length - 1;
      var arr = [];
      var s = a[i];
      if (s !== '') {
        arr.push(s);
      }
      i--;
      for (i; i >= 0; i--) {
        s = a[i];
        arr.push(s);
      }
      arr.reverse();
      return arr.join('\n');
    },
    /**
     * 比较两段文字是否相同
     * @param text
     * @param str
     * @param ignoreEmpty
     * @returns {boolean}
     */
    compareTo: function (text, str, ignoreEmpty) {
      if (text && str) {
        if (ignoreEmpty) {
          return text.trim() === str;
        } else {
          return text === str;
        }
      } else if (!text && !str) {
        return true;
      }
      return false;
    },

    replaceLast: function (text, cfg) {
      function reverse(c) {
        return c.split('').reverse().join('');
      }

      if (!text || !cfg) {
        return text;
      }

      var newCfg;
      var i;
      var l1 = text.length;
      var l2 = cfg.length;
      var endStr;
      if (typeof cfg === 'string') {
        endStr = text.substring(l1 - l2);
        if (endStr === cfg) {
          return text.substring(0, l1 - l2);
        }
      } else if (typeof cfg == 'array') {
        for (i = 0; i < cfg.length; i++) {
          newCfg = cfg[i];
          l2 = newCfg.length;
          endStr = text.substring(l1 - l2);
          if (endStr === newCfg) {
            return text.substring(0, l1 - l2);
          }
        }
        return text;
      } else {
        return text;
      }
    },

    isMultiLineText: function (str) {
      if (_.isUndefined(str) || _.isEmpty(str)) {
        return false;
      }
      var a = this.delimitToParagraphs(str);
      return a.length > 1;
    },

    decode: function (text) {
      var t;
      var i;
      if (text) {
        text = text.replace(/\+/g, '%20');
        try {
          text = decodeURIComponent(text);
        } catch (e) {
          text = decodeURI(text);
        }
      }
      if (this.isMultiLineText(text)) {
        t = this.delimitToParagraphs(text);
        for (i = 0; i < t.length; i++) {
          t[i] = this.convertSpaceToNbsp(t[i]);
        }
        text = t.join('\n');
      } else {
        text = this.convertSpaceToNbsp(text);
      }
      return text;
    }
  },
  /**
   * 颜色处理
   */
  Color: {
    /**
     * 转换为十六进制颜色
     * @param color
     * @returns {string}
     */
    toHex: function (color) {
      if (color.indexOf('#') === 0) {
        return color;
      }
      var c = parseInt(color, 10);
      if (c) {
        color = '#' + c.toString(16);
      }
      return color;
    },

    toRGB: function (color) {
      var c;
      var r,g,b;
      var rgb;
      if(color.indexOf('rgb') === 0) {
        c = color.replace(/\(|\)/g, '').replace('rgb', '').split(',');
        rgb = {
          r: parseInt(c[0].trim(), 10),
          g: parseInt(c[1].trim(), 10),
          b: parseInt(c[2].trim(), 10),
        };
        return rgb;
      } else {
        if (color.indexOf('#') === 0) {
          color = color.replace('#', '');
          c = parseInt(color, 16);
          r = (c >> 16) & 0xff;
          g = (c >> 8) & 0xff;
          b = (c >> 0) & 0xff;
          rgb = {
            r: r,
            g: g,
            b: b,
          };
          return rgb;
        }
      }
    },

    /**
     * 转换为RGBA格式对象
     * @param color
     * @returns {{r:number,g:number,b:number,a:number}}
     */
    toRGBA: function (color) {
      var c;
      var r;
      var g;
      var b;
      var a;
      var rgba;
      if (typeof color === 'string') {
        if (color.indexOf('rgba') === 0) {
          c = color.replace(/\(|\)/g, '').replace('rgba', '').split(',');
          rgba = {
            r: parseInt(c[0].trim(), 10),
            g: parseInt(c[1].trim(), 10),
            b: parseInt(c[2].trim(), 10),
            a: parseFloat(c[3].trim())
          };
          return rgba;
        } else {
          if (color.indexOf('#') === 0) {
            color = color.replace('#', '');
            c = parseInt(color, 16);
          } else {
            c = parseInt(color, 10);
          }
        }
      } else if (typeof color === 'object') {
        return _.extend({}, color);
      } else {
        c = parseInt(color, 10);
      }
      if (color) {
      }
      r = (c >> 16) & 0xff;
      g = (c >> 8) & 0xff;
      b = (c >> 0) & 0xff;
      a = (c >> 24) & 0xff;
      rgba = {
        r: r,
        g: g,
        b: b,
        a: a / 255
      };
      return rgba;
    },

    /**
     * 是否明亮色
     * @param color
     * @returns {boolean}
     */
    isLight: function (color) {
      var c = this.toRGBA(color);
      c = this.toGay(c);
      return (c.r + c.g + c.b) > 128;
    },

    /**
     * 转换为灰色
     * @param color
     * @returns {{r:number,g:number,b:number,a:number}}
     */
    toGay: function (color) {
      var c = this.toRGBA(color);
      c.r *= 0.299;
      c.g *= 0.587;
      c.b *= 0.114;
      return c;
    },

    /**
     * 转换为RGBA格式HTML颜色
     * @param color
     * @returns {string('rgba(r,g,b,a))}
     */
    rgbaToString: function (color) {
      return 'rgba(%d1,%d2,%d3,%d4)'.replace('%d1', color.r).replace('%d2', color.g).replace('%d3', color.b).replace('%d4', color.a);
    },

    /**
     * 转换为HTML颜色
     * @param color
     * @returns {string('rgba(r,g,b,a)')}
     */
    toHTMLColor: function (color) {
      return this.rgbaToString(this.toRGBA(color));
    },

    setOpacity: function (color, opacity) {
      var c = this.toRGBA(color);
      c.a = opacity || 1;
      return this.toHTMLColor(c);
    }
  },
  /**
   * 图像处理
   */
  Bitmap: {
    /**
     * 灰度
     * @param pixes
     */
    gay: function (pixes) {
      for (var i = 0; i < pixes.length; i += 4) {
        pixes[i] = pixes[i + 1] = pixes[i + 2] = pixes[i] * 0.299 + pixes[i + 1] * 0.587 + pixes[i + 2] * 0.114;
      }
    },

    /**
     * 反相
     * @param pixes
     */
    invert: function (pixes) {
      for (var i = 0; i < pixes.length; i += 4) {
        pixes[i] = 255 - pixes[i];
        pixes[i + 1] = 255 - pixes[i + 1];
        pixes[i + 2] = 255 - pixes[i + 2];
      }
    },

    /**
     * 颜色减淡
     * @param basePixes
     * @param mixPixes
     */
    dodgeColor: function (basePixes, mixPixes) {
      for (var i = 0, len = basePixes.length; i < len; i += 4) {
        basePixes[i] = basePixes[i] + (basePixes[i] * mixPixes[i]) / (255 - mixPixes[i]);
        basePixes[i + 1] = basePixes[i + 1] + (basePixes[i + 1] * mixPixes[i + 1]) / (255 - mixPixes[i + 1]);
        basePixes[i + 2] = basePixes[i + 2] + (basePixes[i + 2] * mixPixes[i + 2]) / (255 - mixPixes[i + 2]);
      }
    },
    /**
     * 高斯模糊
     * @param pixes
     * @param width
     * @param height
     * @param radius
     */
    gaussBlur: function (pixes, width, height, radius) {
      var sigma;
      var gaussMatrix = [];
      var gaussSum = 0;
      var x;
      var y;
      var r;
      var g;
      var b;
      var a;
      var i;
      var j;
      var k;
      var len;

      radius = Math.floor(radius) || 3;
      sigma = radius / 3;

      a = 1 / (Math.sqrt(2 * Math.PI) * sigma);
      b = -1 / (2 * sigma * sigma);
      //生成高斯矩阵
      for (i = 0, x = -radius; x <= radius; x++, i++) {
        g = a * Math.exp(b * x * x);
        gaussMatrix[i] = g;
        gaussSum += g;

      }
      //归一化, 保证高斯矩阵的值在[0,1]之间
      for (i = 0, len = gaussMatrix.length; i < len; i++) {
        gaussMatrix[i] /= gaussSum;
      }
      //x 方向一维高斯运算
      for (y = 0; y < height; y++) {
        for (x = 0; x < width; x++) {
          r = g = b = a = 0;
          gaussSum = 0;
          for (j = -radius; j <= radius; j++) {
            k = x + j;
            if (k >= 0 && k < width) { //确保 k 没超出 x 的范围
              //r,g,b,a 四个一组
              i = (y * width + k) * 4;
              r += pixes[i] * gaussMatrix[j + radius];
              g += pixes[i + 1] * gaussMatrix[j + radius];
              b += pixes[i + 2] * gaussMatrix[j + radius];
              // a += pixes[i + 3] * gaussMatrix[j];
              gaussSum += gaussMatrix[j + radius];
            }
          }
          i = (y * width + x) * 4;
          // 除以 gaussSum 是为了消除处于边缘的像素, 高斯运算不足的问题
          // console.log(gaussSum)
          pixes[i] = r / gaussSum;
          pixes[i + 1] = g / gaussSum;
          pixes[i + 2] = b / gaussSum;
          // pixes[i + 3] = a ;
        }
      }
      //y 方向一维高斯运算
      for (x = 0; x < width; x++) {
        for (y = 0; y < height; y++) {
          r = g = b = a = 0;
          gaussSum = 0;
          for (j = -radius; j <= radius; j++) {
            k = y + j;
            if (k >= 0 && k < height) { //确保 k 没超出 y 的范围
              i = (k * width + x) * 4;
              r += pixes[i] * gaussMatrix[j + radius];
              g += pixes[i + 1] * gaussMatrix[j + radius];
              b += pixes[i + 2] * gaussMatrix[j + radius];
              // a += pixes[i + 3] * gaussMatrix[j];
              gaussSum += gaussMatrix[j + radius];
            }
          }
          i = (y * width + x) * 4;
          pixes[i] = r / gaussSum;
          pixes[i + 1] = g / gaussSum;
          pixes[i + 2] = b / gaussSum;
        }
      }
    },

    /**
     * 溶解
     * @param pixes
     */
    dissolve: function (pixes, step) {
      var a;
      for (var i = 0, len = pixes.length; i < len; i += 4) {
        a = Math.random() * 255;
        if (a < 150) {
          a = 0;
        }
        pixes[i + 3] = a;
      }
    },

    /**
     * 实色混合
     * @param basePixes
     * @param mixPixes
     */
    hardMix: function (basePixes, mixPixes) {
      var r;
      var len = basePixes.length;
      for (var i = 0; i < len; i++) {
        if ((i + 1) % 4 !== 0) {
          r = basePixes[i] + mixPixes[i];
          if (r < 255) {
            r = 0;
          }
          if (r > 255) {
            r = 255;
          }
          basePixes[i] = r;
        }
      }
    },

    /**
     * 替换颜色
     * @param pixes
     * @param color
     */
    replacecolor: function (pixes, color) {
      var c = exports.util.Color.toRGBA(color);
      for (var i = 0; i < pixes.length; i += 4) {
        pixes[i] = c.R;
        pixes[i + 1] = c.G;
        pixes[i + 2] = c.B;
        if (pixes[i + 3])
          pixes[i + 3] = c.A * 255;
      }
    }
  },

  Number: {
    toInt: function (value) {
      var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
      var reg = new RegExp('^[0-9]+$');
      if (!_.isUndefined(value) && reg.test(value))
        return parseInt(value, 10);
      return defaultValue;
    },

    toFloat: function (value) {
      var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
      var reg = new RegExp('^-?[0-9]+(\.[0-9]+)?$');
      if (!_.isUndefined(value) && reg.test(value)) {
        try {
          return parseFloat(value);
        } catch (e) {
          return defaultValue
        }
      } else {
        return defaultValue;
      }
    },

    /**
     * 保留小数点位数
     * @param value
     * @param c
     * @returns {number}
     */
    decimalPlaces: function (value, c) {
      var s = 1;
      var i = 0;
      var v;
      if (!c) {
        c = 0;
      } else {
        c = this.toInt(c);
      }
      for (i; i < c; i++) {
        s += '0';
      }
      s = this.toInt(s);
      v = this.toFloat(value);
      return Math.round(v * s) / s;
    }
  },

  Path: {
    Curve: {
      T: undefined,
      curvePointList: [],
      create: function (startPoint, endPoint, controlPoint) {
        var x1 = startPoint.x;
        var x2 = endPoint.x;
        var cx = controlPoint.x;
        var y1 = startPoint.y;
        var y2 = endPoint.y;
        var cy = controlPoint.y;

        var t1 = Math.sqrt(Math.pow(Math.abs(cx - x1), 2) + Math.pow(Math.abs(cy - y1), 2));
        var t2 = Math.sqrt(Math.pow(Math.abs(cx - x2), 2) + Math.pow(Math.abs(cy - y2), 2));
        this.T = Math.ceil(t1 + t2);

        var i;
        var px;
        var py;
        var s = 1 / this.T;
        var t = 0;

        for (i = 0; i < this.T; i++) {
          px = Math.pow(1 - t, 2) * startPoint.x + 2 * t * (1 - t) * controlPoint.x + Math.pow(t, 2) * endPoint.x;
          py = Math.pow(1 - t, 2) * startPoint.y + 2 * t * (1 - t) * controlPoint.y + Math.pow(t, 2) * endPoint.y;
          t += s;
          this.curvePointList.push({x: px, y: py});
        }
      },

      isPointIn: function (x, y, offset) {
        var i = 0;
        var p;
        var r;
        offset = offset || 0;
        for (i; i < this.curvePointList.length; i++) {
          p = this.curvePointList[i];
          r = {left: p.x - offset, top: p.y - offset, right: p.x + offset, bottom: p.y + offset};
          if (r.left < x && r.right > x && r.top < y && r.bottom > y) {
            return true;
          }
        }
        return false;
      }
    },
    PathData: function () {
      var data = [];
      var lastMoveCmd;
      var doClose = false;
      this.moveTo = function (x, y) {
        var cmd = {cmd: 'moveTo', params: [x, y]};
        lastMoveCmd = cmd;
        data.push(cmd);
        return this;
      };

      this.lineTo = function (x, y) {
        data.push({cmd: 'lineTo', params: [x, y]});
        return this;
      };

      this.curveTo = function (cx, cy, x, y) {
        data.push({cmd: 'quadraticCurveTo', params: [cx, cy, x, y]});
        return this;
      };

      this.arc = function (rx, ry, r, startAngle, endAngle) {
        data.push({cmd: 'arc', params: [rx, ry, r, startAngle, endAngle]});
        return this;
      };

      this.close = function () {
        if (lastMoveCmd) {
          //this.lineTo(lastMoveCmd.params.x, lastMoveCmd.params.y);
          this['lineTo'].apply(this, lastMoveCmd.params);
        }
        doClose = true;
        return this;
      };

      this.clear = function () {
        data = [];
        lastMoveCmd = undefined;
        doClose = false;
        return this;
      };

      this.print = function () {
        //console.log(data)
      };

      this.stroke = function (graphics, doFill) {
        var i;
        var cmd;
        var func;
        var params;
        if (doClose)
          graphics.beginPath();
        for (i = 0; i < data.length; i++) {
          cmd = data[i];
          func = cmd.cmd;
          params = cmd.params;
          graphics[func].apply(graphics, params);
        }
        if (doClose)
          graphics.closePath();
        if (doFill) {
          graphics.fill();
        }
        graphics.stroke();
      }
    }

  },

  Util: {
    map: function (count, func, children) {
      var a = [];
      var i;
      var o;
      if (count) {
        if (func) {
          for (i = 0; i < count; i++) {
            if (children) {
              if (children[i]) {
                o = children[i];
              } else {
                o = undefined;
              }
            }
            a.push(func(o, i))
          }
        }
      }
      return a;
    }
  },

  Int: function (value) {
    var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
    return this.Number.toInt(value, defaultValue);
  },

  Float: function (value) {
    var defaultValue = value || arguments.length > 1 ? arguments[1] : 0;
    return this.Number.toFloat(value, defaultValue)
  },

  clone: function (obj) {
    var s;
    var o;
    try {
      s = JSON.stringify(obj);
      o = JSON.parse(s);
    } catch (e) {
      o = null;
    }
    return o;
  },

  depthClone: function (source) {
    function getType(o) {
      return Object.prototype.toString.call(o).replace('[', '').replace(']', '').replace('object', '').trim().toLowerCase();
    }

    function getCloneValue(o) {
      var i;
      var t = getType(o);
      var r;
      if (t === 'number' || t === 'string' || t === 'boolean' || t === 'null' || t === 'undefined') {
        return o;
      } else if (t === 'object') {
        return doClone(o);
      } else if (t === 'function') {
        return o;
      } else if (t === 'array') {
        r = [];
        for (i = 0; i < o.length; i++) {
          r.push(getCloneValue(o[i]));
        }
        return r;
      }
      return o;
    }

    function doClone(o) {
      var k;
      var item;
      var r = {};
      for (k in o) {
        item = o[k];
        r[k] = getCloneValue(item);
      }
      return r;
    }

    return getCloneValue(source);
  }
};


// WEBPACK FOOTER //
// ./src/helper/util.js